import { useTranslation } from 'react-i18next';
import { whatsappUrl } from '@/content/site';
import { WhatsAppIcon, ArrowIcon } from '@/shared/components/Icons';
import styles from './Hero.module.css';

export function Hero() {
  const { t } = useTranslation();

  return (
    <section id="inicio" className={styles.hero}>
      <div className={styles.rings} aria-hidden />
      <div className={`container ${styles.inner}`}>
        <div className={styles.content}>
          <span className="eyebrow">{t('hero.eyebrow')}</span>
          <h1 className={styles.title}>{t('hero.title')}</h1>
          <p className={`lead ${styles.subtitle}`}>{t('hero.subtitle')}</p>
          <div className={styles.actions}>
            <a
              className="btn btn--primary"
              href={whatsappUrl(t('hero.whatsappMessage'))}
              target="_blank"
              rel="noopener noreferrer"
            >
              <WhatsAppIcon width={18} height={18} />
              {t('hero.ctaPrimary')}
            </a>
            <a className="btn btn--ghost" href="#servicios">
              {t('hero.ctaSecondary')}
              <ArrowIcon width={18} height={18} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
